<template>
    <div class="saleoutView">
        <vxe-layout-container vertical>
            <vxe-layout-header>
                <vxe-form :data="formData">
                    <vxe-form-item field="fullname" title="商品全名" span="4">
                        <template #default>
                            <vxe-input v-model="formData.fullname"  placeholder="商品全名" clearable
                                class="form-input" />
                        </template>
                    </vxe-form-item>
                    <vxe-form-item field="customer" title="客户名称" span="4">
                        <template #default>
                            <vxe-input v-model="formData.customer" type="search" placeholder="请输入客户名称" clearable
                                @search-click="handleShowSearchCustomer" @keyup.enter="handleShowSearchCustomer"
                                class="form-input" />
                        </template>
                    </vxe-form-item>
                    <vxe-form-item span="8">
                        <vxe-button type="submit" status="primary" @click="handleSearch">查询</vxe-button>
                        
                    </vxe-form-item>
                </vxe-form>
            </vxe-layout-header>
            <vxe-layout-body>
                <vxe-table border show-overflow height="100%" :data="tableData" stripe
                :row-config="{ isCurrent: true, isHover: true }" show-footer ref="tableref" :loading="loading"
          :cell-config="{ height: 30 }" :footer-data="footerData">
                    <vxe-column type="seq" width="40" title="序号"></vxe-column>
                    

                    <vxe-column field="spbh" title="商品编号" width="120" />
                    <vxe-column field="sP_QM" title="商品全名" width="200" />

                    <vxe-column field="sl" title="数量" width="90" align="right" />
                    <vxe-column field="dj" title="单价" width="110" align="right">
                        <template #default="{ row }">
                            {{ formatMoney(row.dj) }}
                        </template>
                    </vxe-column>
                    <vxe-column field="hj" title="合计" width="120" align="right">
                        <template #default="{ row }">
                            {{ formatMoney(row.hj) }}
                        </template>
                    </vxe-column>

                    

                </vxe-table>
            </vxe-layout-body>
        </vxe-layout-container>
        <!-- 选择客户* -->
        <vxe-modal v-model="showSelectCustomer" width="60vw" height="60vh" destroy-on-close title="客户选择">
            <template #default>
                <selectCustomer @select="handleSelectCustomer" @cancel="showSelectCustomer = false"
                    :MnemonicPhraseProp="formData.customer">
                </selectCustomer>
            </template>
        </vxe-modal>
    </div>
</template>
<script setup>
import { ref, reactive, onMounted } from 'vue'
import { VxeUI } from 'vxe-pc-ui'
import dayjs from 'dayjs'
import request from '@/request/request.js'
import formatMoney  from '../utils/formatMoney'
import { sumNum } from '../utils/calculate'
import selectCustomer from '../components/selectComp/selectCustomerComp.vue'

const loading = ref(false)
const tableData = ref([])
const showSelectCustomer = ref(false)
const tableref = ref()

onMounted(async () => {
    await handleSearch()
})
const handleShowSearchCustomer = async () => {
    showSelectCustomer.value = true
}
const handleSelectCustomer = async (data) => {
    if (data) {
        formData.customer = data.khmc
        formData.customerID = data.bh
    }
    showSelectCustomer.value = false
    await handleSearch()
}
const handlePrint = async (row) => {
    try {
        const res = await axios.post('http://localhost:5000/print', row)
        console.log('打印指令已发送:', res.data)
    } catch (error) {
        console.error('打印失败:', error)
        alert('打印服务未启动，请先打开打印程序')
    }
};

const formData = reactive({
    fullname: '',
    customer: '',
    customerID: ''
})
const handleSearch = async () => {
    if (formData.customerID!='') {
        try {

            loading.value = true
            const res = await request.post('/Saledoc/SalesAnalysis', {
               ProductName:formData.fullname,
                CustomerName: formData.customerID
            })
            tableData.value = res.data
            updateFootEvent()
            // 调用API搜索
            loading.value = false
        } catch (error) {
            loading.value = false
            VxeUI.modal.message({
                id: 'myUniqueMsg',
                content: error,
                status: 'error'
            })
        }
    }
}


// 在值发生改变时更新表尾合计
const updateFootEvent = () => {
    updateFootCount(tableData.value)
}
const updateFootCount = (list) => {
    const [sumNObj] = footerData.value
    sumNObj.hj = sumNum(list, 'hj')
}
const footerData = ref([{ seq: '合计', hj: '0', total: '0' }])
</script>
<style scoped>
.saleoutView {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.table-wrapper {
    flex: 1;
    min-height: 0;
    margin-top: 10px;
}
</style>